import { Search } from "@mui/icons-material";
import { Button } from "@mui/material";
import { debounce, get } from "lodash";
import { useState } from "react";
import Autocomplete from "../../../common/js/components/Autocomplete";
import searchConstants from "../search/constants";

const debounceHandleSearchProxy = debounce((onSearch, term) => {
    onSearch(term);
}, searchConstants["DEBOUNCE_SEARCH_DELAY"]);

const Proxy = (props) => {
    const { errors, onSearch, searchResults, handleAddProxy, userAccount } = props;

    const [selectedProxy, setSelectedProxy] = useState(null);

    const handleUserProxySelection = (p) => {
        const proxyObject = {
            username: get(userAccount, "userAccountKey"),
            proxyFor: p.username,
            personKey: p.personKey,
            name: p.name,
        };
        handleAddProxy(proxyObject);
    };

    return (
        <div style={{ display: "flex", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                    <div style={{ width: "75%" }}>
                        <Autocomplete
                            id="proxyFor"
                            label={"Add Proxy"}
                            error={get(errors, `proxyFor.${0}.proxyFor`, null)}
                            initialInputValue={
                                selectedProxy == null ? "" : `${selectedProxy.firstName} ${selectedProxy.lastName}`
                            }
                            itemToString={(i) => get(i, "firstName", null)}
                            onSelect={(p, b) => setSelectedProxy(p)}
                            placeholder="Enter proxy"
                            searchFunction={(searchInput) => debounceHandleSearchProxy(onSearch, searchInput)}
                            startAdornment={<Search />}
                            suggestions={searchResults}
                            disabled={false}
                            options={{
                                key: "username",
                                display: (suggestion) => {
                                    return (
                                        get(suggestion, "firstName", "") +
                                        " " +
                                        get(suggestion, "lastName", "") +
                                        " (" +
                                        get(suggestion, "username") +
                                        ")"
                                    );
                                },
                            }}
                        />
                    </div>
                    <Button
                        data-testid="add-proxy-button"
                        variant="contained"
                        size="small"
                        disabled={selectedProxy === null}
                        onClick={() => {
                            handleUserProxySelection(selectedProxy);
                            setSelectedProxy(null);
                        }}
                        sx={{ maxHeight: "40px", marginTop: "20px", width: "25%" }}
                    >
                        Add Proxy
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Proxy;
